export default __webpack_public_path__ + "images/98da66e0efe757bbaa0255f0cb14515c.svg";